function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es7.string.pad-start.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.from.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CoreNiotixLogo',
  props: {
    color: {
      type: String,
      required: true,
      "default": '#000'
    },
    dark: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    colorShades: function colorShades() {
      return [this.adjustColor(this.color, this.dark ? 0.75 : 0.25, this.dark), this.adjustColor(this.color, 0.5, this.dark)];
    },
    height: function height() {
      return this.$attrs.height || undefined;
    },
    width: function width() {
      return this.$attrs.width || undefined;
    }
  },
  methods: {
    adjustColor: function adjustColor(hexColor, alpha) {
      var dark = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var hex = hexColor.replace('#', '');

      // remove potential alpha from hex code
      if (hex.length !== 6) {
        hex = hex.substring(0, 3);
      }

      // extend possible 3 character hex to 6 characters
      if (hex.length === 3) {
        hex = hex.replace(/([^#])/g, '$1$1');
      }
      var background = dark ? 0 : 255;
      var _hex$match$map = hex.match(/.{1,2}/g).map(function (color) {
          return Math.floor(parseInt(color, 16) * alpha + background * (1 - alpha)).toString(16).padStart(2, '0');
        }),
        _hex$match$map2 = _slicedToArray(_hex$match$map, 3),
        r = _hex$match$map2[0],
        g = _hex$match$map2[1],
        b = _hex$match$map2[2];
      return "#".concat([r, g, b].join(''));
    }
  }
};